import { Table } from "@tanstack/react-table";
import { Pagination } from "@/components/common/ui/Pagination";

interface DataTablePaginationProps<TData> {
  table: Table<TData>;
  pageSize: number;
  pageSizeOptions: number[];
  showSizeChanger: boolean;
  serverSidePagination: boolean;
  currentPage: number;
  totalPages: number;
  totalRows: number;
  onPageChange?: (page: number) => void;
  onPageSizeChange?: (pageSize: number) => void;
}

export function DataTablePagination<TData>({
  table,
  pageSize,
  pageSizeOptions,
  showSizeChanger,
  serverSidePagination,
  currentPage,
  totalRows,
  onPageChange,
  onPageSizeChange,
}: DataTablePaginationProps<TData>) {
  const handlePageSizeChange = (newSize: number) => {
    if (serverSidePagination && onPageSizeChange) {
      onPageSizeChange(newSize);
    } else {
      table.setPageSize(newSize);
    }
  };

  const handlePageChange = (page: number) => {
    if (serverSidePagination && onPageChange) {
      onPageChange(page);
    } else {
      table.setPageIndex(page - 1);
    }
  };

  return (
    <Pagination
      current={currentPage}
      total={totalRows}
      pageSize={pageSize}
      onChange={handlePageChange}
      pageSizeOptions={pageSizeOptions}
      onPageSizeChange={handlePageSizeChange}
      showTotal
      showSizeChanger={showSizeChanger}
      showFirstLast={true}
      maxPageButtons={3}
      variant="default"
      align="end"
    />
  );
}
